import { useState } from "react";

import DevelopmentAdminNav from "./DevelopmentAdminNav";

import "../../styles/DevelopmentAdmin.css";

function DevelopmentAdminLayout({ children }) {
  const [navigationOpen, setNavigationOpen] =
    useState(false);

  const closeNavigation = () => {
    setNavigationOpen(false);
  };

  return (
    <div
      className={`development-admin-shell${
        navigationOpen ? " nav-open" : ""
      }`}
    >
      <button
        type="button"
        className="development-admin-mobile-toggle"
        onClick={() =>
          setNavigationOpen((current) => !current)
        }
        aria-expanded={navigationOpen}
        aria-label="Toggle Development admin navigation"
      >
        <span />
        <span />
        <span />
      </button>

      <div
        className="development-admin-nav-wrapper"
        onClick={closeNavigation}
      >
        <DevelopmentAdminNav />
      </div>

      {navigationOpen && (
        <button
          type="button"
          className="development-admin-overlay"
          aria-label="Close navigation"
          onClick={closeNavigation}
        />
      )}

      <section className="development-admin-main">
        <header className="development-admin-topbar">
          <div>
            <p className="development-admin-eyebrow">
              Administration
            </p>

            <h1>Avwakin Development</h1>
          </div>

          <NavLinkButton />
        </header>

        <div className="development-admin-content">
          {children}
        </div>
      </section>
    </div>
  );
}

function NavLinkButton() {
  return (
    <a
      href="/avwakindevelopment"
      className="development-admin-topbar-link"
    >
      Public site
    </a>
  );
}

export default DevelopmentAdminLayout;